import { getProjectId, post_data } from "./functions";

export async function removeReadonlyFlag(e) {
  const form = new FormData();
  const version = document
    .getElementById("selectedVersion")
    ?.textContent.split(" ")[1];
  form.append(
    "data",
    JSON.stringify({
      function: "unlock_project",
      id: await getProjectId(),
      version,
      removeFlag: true,
    })
  );
  post_data("./includes/ajax.inc.php", form);
}
